import React from 'react'

export default function TherapyCard({ data, callModal }) {
  return (
    <div
      className="w-[220px] h-[410px] cursor-pointer group border-4 mx-2
      mobile:mb-5 rounded-3xl transition-transform duration-500 
      mobile:w-full mobile:h-[500px]
      extraScreen:w-[300px] extraScreen:h-[500px]
      ease-in-out group-hover:scale-105 group-hover:shadow-xl group-hover:border-4 mt-5  border-white bg-white 
      "
      onClick={() => callModal(data)} 
    >
      <div className="w-full flex flex-col overflow-hidden  rounded-3xl">
        <img src={data.img} alt={data.title} className="h-[280px] mobile:w-full object-cover transition-transform duration-500 ease-in-out 
        mobile:h-[380px]
          extraScreen:w-[300px] extraScreen:h-[380px]
        group-hover:scale-105 group-hover:h-[280px]  mobile:group-hover:h-[380px] extraScreen:group-hover:h-[380px]
 " />
        <div className="h-[100px] flex flex-col justify-start items-center px-4 rounded-b-2xl transition-opacity duration-500
          mobile:h-[110px]
                  extraScreen:h-[110px] group-hover:mt-2
        ">
          <p className="text-[20px] font-inter-bold text-center group-hover:text-primary mt-2 transition-colors duration-500">
            {data.name}
          </p>
          <p className="text-[14px] w-[208px] mobile:w-full text-center font-thin font-inter group-hover:text-gray-700  transition-colors duration-500 ">
            {data.desc}
          </p>
          <p className="text-[12px] w-[208px] mobile:w-full text-center font-thin font-inter group-hover:text-gray-700  transition-colors duration-500 ">
            {data.desc2}
          </p>
        </div>
      </div>
    </div>
  )
}
